export default (color: string, opacity: number): string => {
  if (typeof color !== 'string' || color.length !== 7) return color

  const temp = Math.floor(opacity * 255)
    .toString(16)
    .padStart(2, '0')

  return color + temp
}
